module.exports = __webpack_public_path__ + "files/c581d53bc1d148ad326695ec328e12b5.png";